<template>
<div class="cellinputbox">
<van-row @click="click">
  <van-col span="8">{{label}}</van-col>
  <!-- {{inputValue}} -->
  <van-col span="16">
    <ul class="ulBox">
      <slot name="input"/>

      <div v-for="(item,i) in inputValueList" class="ulBox">
      <li class="liBox" >{{item||''}}</li>
      <!-- v-if="precision&&(precision==i-1)" -->
      <li  style="height: 40px;line-height: 60px;font-weight:700;" v-if="precision&&(length - 1==i)" >.</li>
      </div>
    </ul>
  </van-col>
</van-row>
</div>

</template>
<script>
export default {
  name: 'CustomButton',
  components: {},
   model: {
    prop: 'value',
    event: 'input'
  },
  props: {
   length: {
      type: [String,Number],
      default: 3,
   },
   label: {
      type: String,
      default: "label",
   },
   value: {
      type: [String,Number],
      default: null,
   },
   maxNumber: {
      type: [String,Number],
      default: 99999,
   },
   
   minNumber: {
      type: [String,Number],
      default: null,
   },
  //  精度
   precision: {
      type: [String,Number],
      default: null,
   },
  },
  data() {
    return {
inputValueList:[],
precisionList:[]
    }
  },
  watch:{

 inputValue(newVal,oldVal) {

            if(newVal<0){
                this.$toast('输入不能为负数！');
                this.inputValue = ''
            }
            // 解决数字键盘可以输入输入多个小数点问题
            // 保留两位小数
            if(newVal){
                newVal = newVal.toString();
                if (newVal.length>(this.length + this.precision)) {
                this.inputValue = oldVal
                // this.$toast(`输入最大长度为${this.length+ this.precision}！`);
                // this.$toast(`输入最大值为${this.maxNumber}！`);
                return ;
                }
                // 添加小数点
                if (newVal.length>this.length) {
                newVal = (newVal / (this.precision*10)).toFixed(this.precision)
                }
                if((+newVal > +this.maxNumber)&&this.maxNumber){
                this.inputValue = oldVal
                this.$toast(`输入最大值为${this.maxNumber}！`);
                return ;
                }
                console.log(newVal,oldVal);
            }
  
           let  inputValueList = this.inputValue.toString().split('')||[]
           inputValueList.length = this.length + this.precision
           this.inputValueList = inputValueList
       
        
 
        },
  },
  computed: {
    inputValue: {
      get() {
        return this.value
      },
      set(val) {
        // this.value = val

 
        this.$emit('input', val)

      }
    }
  },
  created() {

  },
mounted () {
  this.init()
    console.log(this.length,2);
},
  methods: {
    click(){
this.$emit('click')
    },
  init(){
  this.inputValueList =[]
  for (let index = 0; index < this.length + this.precision; index++) {
    this.inputValueList.push('')
  }
// console.log(this.inputValueList);


    },

   clickInput() {
    this.$emit("click");
  },
  replayClick(){
    this.inputValue = ''
  },
  },
}
</script>

<style lang="less" scoped>
.cellinputbox{
  height: 50px;
  line-height: 50px;
  font-size: 14px;
  color: #646566;
  padding: 8px;
  .ulBox{
    display: flex;
  }
  .liBox{
    margin: 0 5px;
    width: 40px;
    height: 40px;
    line-height: 40px;
    background: #fff;
    font-size: 22px;
    font-weight: 700;
    text-align: center;
  }
}

  .text{
    font-size: 20px;
    font-weight: normal;
  }
.placeholdertext{
    font-size: 14px;
    color: #929296;
}
  /deep/.style1.van-button--disabled {
    background: #e1e1e1 !important;
    box-shadow: none !important;
    opacity: 1 !important;
  }
</style>
